module.exports = __webpack_public_path__ + "static/media/trusted_companies.a1c4d625.webp";